import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from 'shared/lib/axios';

import {
  CountryWithCalendarsListRequest,
  CountryWithCalendarsList,
  CalendarDTO,
  GetCalendarByIdRequest,
  CreateCalendarEventRequest,
  UpdateCalendarEventRequest,
  CalendarEvent,
  CreateRegionalCalendarRequest,
} from './types';

export const calendarsListGet = (
  payload: CountryWithCalendarsListRequest,
  config?: AxiosRequestConfig,
): Promise<CountryWithCalendarsList> => {
  return axiosInstance.get('/api/country/calendar/all', {
    ...config,
    params: payload,
    paramsSerializer: {
      indexes: null,
    },
  });
};

export const getCalendarById = (payload: GetCalendarByIdRequest, config?: AxiosRequestConfig): Promise<CalendarDTO> => {
  const { id, year } = payload;
  return axiosInstance.get(`/api/calendar/${id}`, { ...config, params: { year } });
};

export const createCalendarEvent = (payload: CreateCalendarEventRequest): Promise<CalendarEvent> => {
  const { calendarId, ...data } = payload;
  return axiosInstance.post(`/api/calendar/${calendarId}/event`, data);
};

export const updateCalendarEvent = (payload: UpdateCalendarEventRequest): Promise<CalendarEvent> => {
  const { calendarId, id, ...data } = payload;
  return axiosInstance.put(`/api/calendar/${calendarId}/event/${id}`, data);
};

export const deleteCalendarEvent = (calendarId: string, eventId: string): Promise<void> => {
  return axiosInstance.delete(`/api/calendar/${calendarId}/event/${eventId}`);
};

export const createRegionalCalendar = (payload: CreateRegionalCalendarRequest): Promise<CalendarDTO> => {
  const { countryId, year, name } = payload;
  return axiosInstance.post(`/api/country/${countryId}/calendar/regional`, { name }, { params: { year } });
};

export const updateRegionalCalendar = (id: string, name: string): Promise<CalendarDTO> => {
  return axiosInstance.put(`/api/calendar/${id}`, { name });
};

export const deleteRegionalCalendar = (id: string): Promise<void> => {
  return axiosInstance.delete(`/api/calendar/${id}`);
};
